import React from 'react';
import { Button } from 'antd';

const WatchedAndRepliedTypes = ({ watchedTypes, watched, replied, repliedTypes, onChangeWatchedList, onChangeRepliedList }) => {
  const watchedRequests = watchedTypes && watchedTypes.filter(item => item.type === 'watched');
  const unwatchedRequests = watchedTypes && watchedTypes.filter(item => item.type === 'unwatched');

  const repliedRequests = repliedTypes && repliedTypes.filter(item => item.type === 'replied');
  const notRepliedRequests = repliedTypes && repliedTypes.filter(item => item.type === 'notReplied');

  return (
    <>
      <div className="b-table-filters__col5 watched-and-replied-types">
        <Button
          value={true}
          type="normal"
          size="small"
          style={{ marginRight: '16px' }}
          className={replied === 'replied' ? 'active watched-and-replied-types__btn' : 'watched-and-replied-types__btn'}
          onClick={onChangeRepliedList}
        >
          {repliedRequests && repliedRequests[0].count
            ? `Отвеченные: ${repliedRequests[0].count}`
            : 'Отвеченные'}
        </Button>
        <Button
          value={false}
          type="normal"
          size="small"
          style={{ marginRight: '16px' }}
          className={replied === 'notReplied' ? 'active watched-and-replied-types__btn' : 'watched-and-replied-types__btn'}
          onClick={onChangeRepliedList}
        >
          {notRepliedRequests && notRepliedRequests[0].count > 0
            ? `Неотвеченные: ${notRepliedRequests[0].count}`
            : 'Неотвеченные'}
        </Button>
        <Button
          value={true}
          type="normal"
          size="small"
          style={{ marginRight: '16px' }}
          className={watched === 'watched' ? 'active watched-and-replied-types__btn' : 'watched-and-replied-types__btn'}
          onClick={onChangeWatchedList}
        >
          {watchedRequests && watchedRequests[0].count
            ? `Просмотренные: ${watchedRequests[0].count}`
            : 'Просмотренные'}
        </Button>
        <Button
          value={false}
          type="normal"
          size="small"
          style={{ marginRight: '16px' }}
          className={watched === 'unwatched' ? 'active watched-and-replied-types__btn' : 'watched-and-replied-types__btn'}
          onClick={onChangeWatchedList}
        >
          {unwatchedRequests && unwatchedRequests[0].count > 0
            ? `Непросмотренные: ${unwatchedRequests[0].count}`
            : 'Непросмотренные'}
        </Button>
      </div>
    </>
  );
};

export default WatchedAndRepliedTypes;
